/** Phase 2B test ids — append to TIDS_P2 import */
export const TIDS_P2B = {
    // games hub
    gamesHub: "games-hub",
    gameTile: (slug) => `game-tile-${slug}`,

    // coloring
    coloringPage: "coloring-page",
    coloringTemplate: (id) => `coloring-template-${id}`,
    coloringSwatch: (color) => `coloring-swatch-${color}`,
    coloringClear: "coloring-clear",
    coloringSave: "coloring-save",

    // memory game
    memoryPage: "memory-page",
    memoryCard: (i) => `memory-card-${i}`,
    memoryReset: "memory-reset",
    memoryWin: "memory-win",

    // word search
    wordSearchPage: "word-search-page",
    wordSearchCell: (r, c) => `ws-cell-${r}-${c}`,
    wordSearchReset: "ws-reset",

    // restoration
    restorationPage: "restoration-page",
    restorationNewBtn: "restoration-new-btn",
    restorationPlan: (id) => `restoration-plan-${id}`,
    restorationStep: (id) => `restoration-step-${id}`,
    restorationStepInput: (id) => `restoration-step-input-${id}`,
    restorationStepSave: (id) => `restoration-step-save-${id}`,

    // reentry checklist
    reentryPage: "reentry-checklist-page",
    reentryItem: (id) => `reentry-item-${id}`,
    reentryToggle: (id) => `reentry-toggle-${id}`,

    // resources
    resourcesPage: "resources-page",
    resourceCard: (id) => `resource-card-${id}`,
    resourceDetail: "resource-detail",
};
